import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Text from 'components/common/Text/Text'
import Link from './Link'
import ArrowIconFullBrightRedRight from 'components/common/Icon/assets/arrow-icon-full-bright-red-right.svg'

const FollowLink = ({ children, block = true, followLinkTextProps = {}, ...props }) => (
  <LinkWrapper block={ block } { ...props }>
    <LinkText data-at-follow-link-text narrow follow_link { ...followLinkTextProps }>{ children }</LinkText>
  </LinkWrapper>
)

FollowLink.propTypes = {
  block: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  followLinkTextProps: PropTypes.shape()
}

export default FollowLink

const LinkWrapper = styled(Link)`
  color: ${Theme.colors.black};
  ${Mixin.responsive('margin-top', '16px', '12px')}
`

const LinkText = styled(Text)`
  &::after {
    content: '';
    background-image: url(${ArrowIconFullBrightRedRight});
    display: inline-block;
    background-repeat: no-repeat;
    background-size: contain;
    height: 15px;
    width: 5px;
    margin-left: 5px;
    position: relative;
    top: 5px;
  }
`
